// src/pages/PaymentSuccess.jsx
import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle, Package } from 'lucide-react';
import cinetpayService from '../services/cinetpayService';

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const processPayment = async () => {
      try {
        const transactionId = searchParams.get('transaction_id');
        const orderId = searchParams.get('order_id');
        
        if (!transactionId || !orderId) {
          console.error('Missing payment parameters');
          navigate('/');
          return;
        }

        // Vérifier le statut du paiement
        const orderData = await cinetpayService.getOrder(orderId);
        
        if (orderData && orderData.status === 'paid') {
          setOrder(orderData);
        } else {
          // Rediriger vers la page d'échec
          navigate(`/payment/failed?transaction_id=${transactionId}`);
        }
      } catch (error) {
        console.error('Payment processing error:', error);
        navigate('/');
      } finally {
        setLoading(false);
      }
    };

    processPayment();
  }, [searchParams, navigate]);

  if (loading) {
    return (
      <div className="success-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Vérification de votre paiement...</p>
        </div>
      </div>
    );
  }

  if (!order) {
    return null;
  }

  return (
    <div className="success-container">
      <div className="success-card">
        <div className="success-icon">
          <CheckCircle size={64} />
        </div>
        <h1>Paiement Réussi !</h1>
        <p className="success-message">
          Votre commande a été confirmée et sera traitée dans les plus brefs délais.
        </p>
        
        <div className="order-details">
          <h3>Récapitulatif de votre commande</h3>
          <div className="detail-item">
            <Package size={18} />
            <span>Pack:</span>
            <strong>{order.packName}</strong>
          </div>
          <div className="detail-item">
            <span>N° Commande:</span>
            <strong>{order.orderId}</strong>
          </div>
          <div className="detail-item">
            <span>Montant:</span>
            <strong>{order.amount} XOF</strong>
          </div>
          <div className="detail-item">
            <span>Statut:</span>
            <strong className="status-paid">Payée</strong>
          </div>
        </div>

        <div className="next-steps">
          <h4>Prochaines étapes :</h4>
          <ul>
            <li>Vous recevrez un SMS de confirmation</li>
            <li>Notre équipe logistique vous contactera pour la livraison</li>
            <li>Délai de livraison : 24-48h à Abidjan</li>
          </ul>
        </div>

        <button 
          onClick={() => navigate('/')}
          className="home-button"
        >
          Retour à l'accueil
        </button>
      </div>
    </div>
  );
}